import { Milestone } from 'data/records'
import { resource, collection, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(Milestone, [
  ['list', collection.get('', ['goalId', 'privacyCode'])]
])

const selectors = {
  ...findSelector(Milestone),
  byGoalId: (state, goalId) => state.apiv3.milestone.id.filter(m => m.goalId === goalId)
}

const reducers = {}

const initialState = {}

export {
  api as milestoneApi,
  actions as milestoneActions,
  selectors as milestoneSelectors,
  reducers as milestoneReducers,
  initialState as milestoneInitialState
}
